import { useBillingStore } from '@/store/stores/billing'

export async function ensureProjectBillingLoaded(projectId, project) {
    if (!projectId || !project?.billingEnabled) {
        return
    }

    const billingStore = useBillingStore()
    if (billingStore.isCurrentTariffFetched(projectId)) {
        return
    }

    await billingStore.fetchCurrentTariff(projectId)
}
